namespace GeniuzPOS.InitialData {
    export interface PsSalesmanRow {
        Id?: number;
        SalesmanId?: string;
        SalesmanGroup?: string;
        SalesmanName?: string;
        SalesmanIDName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        SalesmanGroupDesc?: string;
    }

    export namespace PsSalesmanRow {
        export const idProperty = 'SalesmanId';
        export const nameProperty = 'SalesmanIDName';
        export const localTextPrefix = 'InitialData.PsSalesman';
        export const lookupKey = 'InitialData.PsSalesman';

        export function getLookup(): Q.Lookup<PsSalesmanRow> {
            return Q.getLookup<PsSalesmanRow>('InitialData.PsSalesman');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:พนักงานขาย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SalesmanId = "SalesmanId",
            SalesmanGroup = "SalesmanGroup",
            SalesmanName = "SalesmanName",
            SalesmanIDName = "SalesmanIDName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            SalesmanGroupDesc = "SalesmanGroupDesc"
        }
    }
}
